<template>
  <post-container :key="check" @refresh="refresh"></post-container>
</template>

<script>
import { PostContainer } from "@/components";

export default {
  components: {
    PostContainer,
  },
  data() {
    return {
      check: 0,
    };
  },
  methods: {
    refresh() {
      this.check += 1;
      console.log(this.check);
    },
  },
};
</script>
<style lang="scss" scoped></style>
